
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {OrderSide} from '../core/OrderSide';
import {FieldModelOrderSide} from '../core/OrderSide';
import {OrderType} from '../core/OrderType';
import {FieldModelOrderType} from '../core/OrderType';
import {OrderTimeInForce} from '../core/OrderTimeInForce';
import {FieldModelOrderTimeInForce} from '../core/OrderTimeInForce';
import {OrderStatus} from '../core/OrderStatus';
import {FieldModelOrderStatus} from '../core/OrderStatus';
import {OrderRequestSourceType} from '../core/OrderRequestSourceType';
import {FieldModelOrderRequestSourceType} from '../core/OrderRequestSourceType';
import {SocialTradingOrderType} from '../core/SocialTradingOrderType';
import {FieldModelSocialTradingOrderType} from '../core/SocialTradingOrderType';
import {SocialTradingOrderInvestorUpdate} from './SocialTradingOrderInvestorUpdate';
import {FieldModelSocialTradingOrderInvestorUpdate} from './SocialTradingOrderInvestorUpdate';
import {SocialTradingOrderMasterUpdate} from './SocialTradingOrderMasterUpdate';
import {FieldModelSocialTradingOrderMasterUpdate} from './SocialTradingOrderMasterUpdate';

/**
 * OrderUpdate struct
 */
class OrderUpdate {
  /**
   * Initialize struct
   * @param {!number=} key
   * @param {number=} parentOrderId
   * @param {!boolean=} parentOrderIdReset
   * @param {number=} actualVersion
   * @param {UUID=} symbolId
   * @param {OrderSide=} orderSide
   * @param {OrderType=} orderType
   * @param {OrderType=} orderInitialType
   * @param {OrderTimeInForce=} orderTimeInForce
   * @param {!boolean=} orderTimeInForceReset
   * @param {OrderStatus=} orderStatus
   * @param {number=} price
   * @param {!boolean=} priceReset
   * @param {number=} stopPrice
   * @param {!boolean=} stopPriceReset
   * @param {number=} takeProfit
   * @param {!boolean=} takeProfitReset
   * @param {number=} stopLoss
   * @param {!boolean=} stopLossReset
   * @param {number=} amount
   * @param {number=} executedAmount
   * @param {number=} remainingAmount
   * @param {Date=} expiration
   * @param {!boolean=} expirationReset
   * @param {string=} accountComment
   * @param {string=} managerComment
   * @param {number=} magic
   * @param {!boolean=} magicReset
   * @param {Date=} created
   * @param {Date=} modified
   * @param {Date=} archived
   * @param {Date=} deleted
   * @param {number=} openPrice
   * @param {!boolean=} openPriceReset
   * @param {number=} closePrice
   * @param {!boolean=} closePriceReset
   * @param {number=} closeAmount
   * @param {!boolean=} closeAmountReset
   * @param {number=} openMarginRate
   * @param {!boolean=} openMarginRateReset
   * @param {number=} commission
   * @param {!boolean=} commissionReset
   * @param {number=} swapChange
   * @param {!boolean=} swapChangeReset
   * @param {number=} openMarkup
   * @param {UUID=} gatewayId
   * @param {number=} closeProfit
   * @param {!boolean=} closeProfitReset
   * @param {Date=} opened
   * @param {Date=} closed
   * @param {number=} openAccountMargin
   * @param {!boolean=} openAccountMarginReset
   * @param {number=} openAccountEquity
   * @param {!boolean=} openAccountEquityReset
   * @param {number=} openAccountCredit
   * @param {!boolean=} openAccountCreditReset
   * @param {number=} openAmount
   * @param {!boolean=} openAmountReset
   * @param {OrderRequestSourceType=} orderRequestSourceType
   * @param {boolean=} isCreatedViaQuickTrading
   * @param {!boolean=} isCreatedViaQuickTradingReset
   * @param {boolean=} isCreatedViaFastTrader
   * @param {!boolean=} isCreatedViaFastTraderReset
   * @param {SocialTradingOrderType=} socialTradingOrderType
   * @param {SocialTradingOrderInvestorUpdate=} socialTradingOrderInvestorUpdate
   * @param {!boolean=} socialTradingOrderInvestorUpdateReset
   * @param {SocialTradingOrderMasterUpdate=} socialTradingOrderMasterUpdate
   * @param {!boolean=} socialTradingOrderMasterUpdateReset
   * @param {SocialTradingOrderType=} socialTradingOrderInitialType
   * @param {SocialTradingOrderInvestorUpdate=} socialTradingOrderInitialInvestorUpdate
   * @param {!boolean=} socialTradingOrderInitialInvestorUpdateReset
   * @param {SocialTradingOrderMasterUpdate=} socialTradingOrderInitialMasterUpdate
   * @param {!boolean=} socialTradingOrderInitialMasterUpdateReset
   * @constructor
   */
  constructor (key = new UInt64(0, 0), parentOrderId = null, parentOrderIdReset = false, actualVersion = null, symbolId = null, orderSide = null, orderType = null, orderInitialType = null, orderTimeInForce = null, orderTimeInForceReset = false, orderStatus = null, price = null, priceReset = false, stopPrice = null, stopPriceReset = false, takeProfit = null, takeProfitReset = false, stopLoss = null, stopLossReset = false, amount = null, executedAmount = null, remainingAmount = null, expiration = null, expirationReset = false, accountComment = null, managerComment = null, magic = null, magicReset = false, created = null, modified = null, archived = null, deleted = null, openPrice = null, openPriceReset = false, closePrice = null, closePriceReset = false, closeAmount = null, closeAmountReset = false, openMarginRate = null, openMarginRateReset = false, commission = null, commissionReset = false, swapChange = null, swapChangeReset = false, openMarkup = null, gatewayId = null, closeProfit = null, closeProfitReset = false, opened = null, closed = null, openAccountMargin = null, openAccountMarginReset = false, openAccountEquity = null, openAccountEquityReset = false, openAccountCredit = null, openAccountCreditReset = false, openAmount = null, openAmountReset = false, orderRequestSourceType = null, isCreatedViaQuickTrading = null, isCreatedViaQuickTradingReset = false, isCreatedViaFastTrader = null, isCreatedViaFastTraderReset = false, socialTradingOrderType = null, socialTradingOrderInvestorUpdate = null, socialTradingOrderInvestorUpdateReset = false, socialTradingOrderMasterUpdate = null, socialTradingOrderMasterUpdateReset = false, socialTradingOrderInitialType = null, socialTradingOrderInitialInvestorUpdate = null, socialTradingOrderInitialInvestorUpdateReset = false, socialTradingOrderInitialMasterUpdate = null, socialTradingOrderInitialMasterUpdateReset = false) {
    this.Key = key
    this.ParentOrderId = parentOrderId
    this.ParentOrderIdReset = parentOrderIdReset
    this.ActualVersion = actualVersion
    this.SymbolId = symbolId
    this.OrderSide = orderSide
    this.OrderType = orderType
    this.OrderInitialType = orderInitialType
    this.OrderTimeInForce = orderTimeInForce
    this.OrderTimeInForceReset = orderTimeInForceReset
    this.OrderStatus = orderStatus
    this.Price = price
    this.PriceReset = priceReset
    this.StopPrice = stopPrice
    this.StopPriceReset = stopPriceReset
    this.TakeProfit = takeProfit
    this.TakeProfitReset = takeProfitReset
    this.StopLoss = stopLoss
    this.StopLossReset = stopLossReset
    this.Amount = amount
    this.ExecutedAmount = executedAmount
    this.RemainingAmount = remainingAmount
    this.Expiration = expiration
    this.ExpirationReset = expirationReset
    this.AccountComment = accountComment
    this.ManagerComment = managerComment
    this.Magic = magic
    this.MagicReset = magicReset
    this.Created = created
    this.Modified = modified
    this.Archived = archived
    this.Deleted = deleted
    this.OpenPrice = openPrice
    this.OpenPriceReset = openPriceReset
    this.ClosePrice = closePrice
    this.ClosePriceReset = closePriceReset
    this.CloseAmount = closeAmount
    this.CloseAmountReset = closeAmountReset
    this.OpenMarginRate = openMarginRate
    this.OpenMarginRateReset = openMarginRateReset
    this.Commission = commission
    this.CommissionReset = commissionReset
    this.SwapChange = swapChange
    this.SwapChangeReset = swapChangeReset
    this.OpenMarkup = openMarkup
    this.GatewayId = gatewayId
    this.CloseProfit = closeProfit
    this.CloseProfitReset = closeProfitReset
    this.Opened = opened
    this.Closed = closed
    this.OpenAccountMargin = openAccountMargin
    this.OpenAccountMarginReset = openAccountMarginReset
    this.OpenAccountEquity = openAccountEquity
    this.OpenAccountEquityReset = openAccountEquityReset
    this.OpenAccountCredit = openAccountCredit
    this.OpenAccountCreditReset = openAccountCreditReset
    this.OpenAmount = openAmount
    this.OpenAmountReset = openAmountReset
    this.OrderRequestSourceType = orderRequestSourceType
    this.IsCreatedViaQuickTrading = isCreatedViaQuickTrading
    this.IsCreatedViaQuickTradingReset = isCreatedViaQuickTradingReset
    this.IsCreatedViaFastTrader = isCreatedViaFastTrader
    this.IsCreatedViaFastTraderReset = isCreatedViaFastTraderReset
    this.SocialTradingOrderType = socialTradingOrderType
    this.SocialTradingOrderInvestorUpdate = socialTradingOrderInvestorUpdate
    this.SocialTradingOrderInvestorUpdateReset = socialTradingOrderInvestorUpdateReset
    this.SocialTradingOrderMasterUpdate = socialTradingOrderMasterUpdate
    this.SocialTradingOrderMasterUpdateReset = socialTradingOrderMasterUpdateReset
    this.SocialTradingOrderInitialType = socialTradingOrderInitialType
    this.SocialTradingOrderInitialInvestorUpdate = socialTradingOrderInitialInvestorUpdate
    this.SocialTradingOrderInitialInvestorUpdateReset = socialTradingOrderInitialInvestorUpdateReset
    this.SocialTradingOrderInitialMasterUpdate = socialTradingOrderInitialMasterUpdate
    this.SocialTradingOrderInitialMasterUpdateReset = socialTradingOrderInitialMasterUpdateReset
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderUpdate}
   * @param {!OrderUpdate} other Other struct
   * @returns {!OrderUpdate} This struct
   */
  copy (other) {
    if (other.Key != null) {
      this.Key = UInt64.fromNumber(other.Key)
    } else {
      this.Key = null
    }
    if (other.ParentOrderId != null) {
      this.ParentOrderId = UInt64.fromNumber(other.ParentOrderId)
    } else {
      this.ParentOrderId = null
    }
    if (other.ParentOrderIdReset != null) {
      this.ParentOrderIdReset = other.ParentOrderIdReset
    } else {
      this.ParentOrderIdReset = null
    }
    if (other.ActualVersion != null) {
      this.ActualVersion = UInt64.fromNumber(other.ActualVersion)
    } else {
      this.ActualVersion = null
    }
    if (other.SymbolId != null) {
      this.SymbolId = new UUID(other.SymbolId)
    } else {
      this.SymbolId = null
    }
    if (other.OrderSide != null) {
      this.OrderSide = OrderSide.fromObject(other.OrderSide)
    } else {
      this.OrderSide = null
    }
    if (other.OrderType != null) {
      this.OrderType = OrderType.fromObject(other.OrderType)
    } else {
      this.OrderType = null
    }
    if (other.OrderInitialType != null) {
      this.OrderInitialType = OrderType.fromObject(other.OrderInitialType)
    } else {
      this.OrderInitialType = null
    }
    if (other.OrderTimeInForce != null) {
      this.OrderTimeInForce = OrderTimeInForce.fromObject(other.OrderTimeInForce)
    } else {
      this.OrderTimeInForce = null
    }
    if (other.OrderTimeInForceReset != null) {
      this.OrderTimeInForceReset = other.OrderTimeInForceReset
    } else {
      this.OrderTimeInForceReset = null
    }
    if (other.OrderStatus != null) {
      this.OrderStatus = OrderStatus.fromObject(other.OrderStatus)
    } else {
      this.OrderStatus = null
    }
    if (other.Price != null) {
      this.Price = other.Price
    } else {
      this.Price = null
    }
    if (other.PriceReset != null) {
      this.PriceReset = other.PriceReset
    } else {
      this.PriceReset = null
    }
    if (other.StopPrice != null) {
      this.StopPrice = other.StopPrice
    } else {
      this.StopPrice = null
    }
    if (other.StopPriceReset != null) {
      this.StopPriceReset = other.StopPriceReset
    } else {
      this.StopPriceReset = null
    }
    if (other.TakeProfit != null) {
      this.TakeProfit = other.TakeProfit
    } else {
      this.TakeProfit = null
    }
    if (other.TakeProfitReset != null) {
      this.TakeProfitReset = other.TakeProfitReset
    } else {
      this.TakeProfitReset = null
    }
    if (other.StopLoss != null) {
      this.StopLoss = other.StopLoss
    } else {
      this.StopLoss = null
    }
    if (other.StopLossReset != null) {
      this.StopLossReset = other.StopLossReset
    } else {
      this.StopLossReset = null
    }
    if (other.Amount != null) {
      this.Amount = other.Amount
    } else {
      this.Amount = null
    }
    if (other.ExecutedAmount != null) {
      this.ExecutedAmount = other.ExecutedAmount
    } else {
      this.ExecutedAmount = null
    }
    if (other.RemainingAmount != null) {
      this.RemainingAmount = other.RemainingAmount
    } else {
      this.RemainingAmount = null
    }
    if (other.Expiration != null) {
      if (other.Expiration instanceof Date) {
        this.Expiration = new Date(other.Expiration.getTime())
      } else {
        this.Expiration = new Date(Math.round(other.Expiration / 1000000))
      }
    } else {
      this.Expiration = null
    }
    if (other.ExpirationReset != null) {
      this.ExpirationReset = other.ExpirationReset
    } else {
      this.ExpirationReset = null
    }
    if (other.AccountComment != null) {
      this.AccountComment = other.AccountComment
    } else {
      this.AccountComment = null
    }
    if (other.ManagerComment != null) {
      this.ManagerComment = other.ManagerComment
    } else {
      this.ManagerComment = null
    }
    if (other.Magic != null) {
      this.Magic = other.Magic
    } else {
      this.Magic = null
    }
    if (other.MagicReset != null) {
      this.MagicReset = other.MagicReset
    } else {
      this.MagicReset = null
    }
    if (other.Created != null) {
      if (other.Created instanceof Date) {
        this.Created = new Date(other.Created.getTime())
      } else {
        this.Created = new Date(Math.round(other.Created / 1000000))
      }
    } else {
      this.Created = null
    }
    if (other.Modified != null) {
      if (other.Modified instanceof Date) {
        this.Modified = new Date(other.Modified.getTime())
      } else {
        this.Modified = new Date(Math.round(other.Modified / 1000000))
      }
    } else {
      this.Modified = null
    }
    if (other.Archived != null) {
      if (other.Archived instanceof Date) {
        this.Archived = new Date(other.Archived.getTime())
      } else {
        this.Archived = new Date(Math.round(other.Archived / 1000000))
      }
    } else {
      this.Archived = null
    }
    if (other.Deleted != null) {
      if (other.Deleted instanceof Date) {
        this.Deleted = new Date(other.Deleted.getTime())
      } else {
        this.Deleted = new Date(Math.round(other.Deleted / 1000000))
      }
    } else {
      this.Deleted = null
    }
    if (other.OpenPrice != null) {
      this.OpenPrice = other.OpenPrice
    } else {
      this.OpenPrice = null
    }
    if (other.OpenPriceReset != null) {
      this.OpenPriceReset = other.OpenPriceReset
    } else {
      this.OpenPriceReset = null
    }
    if (other.ClosePrice != null) {
      this.ClosePrice = other.ClosePrice
    } else {
      this.ClosePrice = null
    }
    if (other.ClosePriceReset != null) {
      this.ClosePriceReset = other.ClosePriceReset
    } else {
      this.ClosePriceReset = null
    }
    if (other.CloseAmount != null) {
      this.CloseAmount = other.CloseAmount
    } else {
      this.CloseAmount = null
    }
    if (other.CloseAmountReset != null) {
      this.CloseAmountReset = other.CloseAmountReset
    } else {
      this.CloseAmountReset = null
    }
    if (other.OpenMarginRate != null) {
      this.OpenMarginRate = other.OpenMarginRate
    } else {
      this.OpenMarginRate = null
    }
    if (other.OpenMarginRateReset != null) {
      this.OpenMarginRateReset = other.OpenMarginRateReset
    } else {
      this.OpenMarginRateReset = null
    }
    if (other.Commission != null) {
      this.Commission = other.Commission
    } else {
      this.Commission = null
    }
    if (other.CommissionReset != null) {
      this.CommissionReset = other.CommissionReset
    } else {
      this.CommissionReset = null
    }
    if (other.SwapChange != null) {
      this.SwapChange = other.SwapChange
    } else {
      this.SwapChange = null
    }
    if (other.SwapChangeReset != null) {
      this.SwapChangeReset = other.SwapChangeReset
    } else {
      this.SwapChangeReset = null
    }
    if (other.OpenMarkup != null) {
      this.OpenMarkup = UInt64.fromNumber(other.OpenMarkup)
    } else {
      this.OpenMarkup = null
    }
    if (other.GatewayId != null) {
      this.GatewayId = new UUID(other.GatewayId)
    } else {
      this.GatewayId = null
    }
    if (other.CloseProfit != null) {
      this.CloseProfit = other.CloseProfit
    } else {
      this.CloseProfit = null
    }
    if (other.CloseProfitReset != null) {
      this.CloseProfitReset = other.CloseProfitReset
    } else {
      this.CloseProfitReset = null
    }
    if (other.Opened != null) {
      if (other.Opened instanceof Date) {
        this.Opened = new Date(other.Opened.getTime())
      } else {
        this.Opened = new Date(Math.round(other.Opened / 1000000))
      }
    } else {
      this.Opened = null
    }
    if (other.Closed != null) {
      if (other.Closed instanceof Date) {
        this.Closed = new Date(other.Closed.getTime())
      } else {
        this.Closed = new Date(Math.round(other.Closed / 1000000))
      }
    } else {
      this.Closed = null
    }
    if (other.OpenAccountMargin != null) {
      this.OpenAccountMargin = other.OpenAccountMargin
    } else {
      this.OpenAccountMargin = null
    }
    if (other.OpenAccountMarginReset != null) {
      this.OpenAccountMarginReset = other.OpenAccountMarginReset
    } else {
      this.OpenAccountMarginReset = null
    }
    if (other.OpenAccountEquity != null) {
      this.OpenAccountEquity = other.OpenAccountEquity
    } else {
      this.OpenAccountEquity = null
    }
    if (other.OpenAccountEquityReset != null) {
      this.OpenAccountEquityReset = other.OpenAccountEquityReset
    } else {
      this.OpenAccountEquityReset = null
    }
    if (other.OpenAccountCredit != null) {
      this.OpenAccountCredit = other.OpenAccountCredit
    } else {
      this.OpenAccountCredit = null
    }
    if (other.OpenAccountCreditReset != null) {
      this.OpenAccountCreditReset = other.OpenAccountCreditReset
    } else {
      this.OpenAccountCreditReset = null
    }
    if (other.OpenAmount != null) {
      this.OpenAmount = other.OpenAmount
    } else {
      this.OpenAmount = null
    }
    if (other.OpenAmountReset != null) {
      this.OpenAmountReset = other.OpenAmountReset
    } else {
      this.OpenAmountReset = null
    }
    if (other.OrderRequestSourceType != null) {
      this.OrderRequestSourceType = OrderRequestSourceType.fromObject(other.OrderRequestSourceType)
    } else {
      this.OrderRequestSourceType = null
    }
    if (other.IsCreatedViaQuickTrading != null) {
      this.IsCreatedViaQuickTrading = other.IsCreatedViaQuickTrading
    } else {
      this.IsCreatedViaQuickTrading = null
    }
    if (other.IsCreatedViaQuickTradingReset != null) {
      this.IsCreatedViaQuickTradingReset = other.IsCreatedViaQuickTradingReset
    } else {
      this.IsCreatedViaQuickTradingReset = null
    }
    if (other.IsCreatedViaFastTrader != null) {
      this.IsCreatedViaFastTrader = other.IsCreatedViaFastTrader
    } else {
      this.IsCreatedViaFastTrader = null
    }
    if (other.IsCreatedViaFastTraderReset != null) {
      this.IsCreatedViaFastTraderReset = other.IsCreatedViaFastTraderReset
    } else {
      this.IsCreatedViaFastTraderReset = null
    }
    if (other.SocialTradingOrderType != null) {
      this.SocialTradingOrderType = SocialTradingOrderType.fromObject(other.SocialTradingOrderType)
    } else {
      this.SocialTradingOrderType = null
    }
    if (other.SocialTradingOrderInvestorUpdate != null) {
      this.SocialTradingOrderInvestorUpdate = SocialTradingOrderInvestorUpdate.fromObject(other.SocialTradingOrderInvestorUpdate)
    } else {
      this.SocialTradingOrderInvestorUpdate = null
    }
    if (other.SocialTradingOrderInvestorUpdateReset != null) {
      this.SocialTradingOrderInvestorUpdateReset = other.SocialTradingOrderInvestorUpdateReset
    } else {
      this.SocialTradingOrderInvestorUpdateReset = null
    }
    if (other.SocialTradingOrderMasterUpdate != null) {
      this.SocialTradingOrderMasterUpdate = SocialTradingOrderMasterUpdate.fromObject(other.SocialTradingOrderMasterUpdate)
    } else {
      this.SocialTradingOrderMasterUpdate = null
    }
    if (other.SocialTradingOrderMasterUpdateReset != null) {
      this.SocialTradingOrderMasterUpdateReset = other.SocialTradingOrderMasterUpdateReset
    } else {
      this.SocialTradingOrderMasterUpdateReset = null
    }
    if (other.SocialTradingOrderInitialType != null) {
      this.SocialTradingOrderInitialType = SocialTradingOrderType.fromObject(other.SocialTradingOrderInitialType)
    } else {
      this.SocialTradingOrderInitialType = null
    }
    if (other.SocialTradingOrderInitialInvestorUpdate != null) {
      this.SocialTradingOrderInitialInvestorUpdate = SocialTradingOrderInvestorUpdate.fromObject(other.SocialTradingOrderInitialInvestorUpdate)
    } else {
      this.SocialTradingOrderInitialInvestorUpdate = null
    }
    if (other.SocialTradingOrderInitialInvestorUpdateReset != null) {
      this.SocialTradingOrderInitialInvestorUpdateReset = other.SocialTradingOrderInitialInvestorUpdateReset
    } else {
      this.SocialTradingOrderInitialInvestorUpdateReset = null
    }
    if (other.SocialTradingOrderInitialMasterUpdate != null) {
      this.SocialTradingOrderInitialMasterUpdate = SocialTradingOrderMasterUpdate.fromObject(other.SocialTradingOrderInitialMasterUpdate)
    } else {
      this.SocialTradingOrderInitialMasterUpdate = null
    }
    if (other.SocialTradingOrderInitialMasterUpdateReset != null) {
      this.SocialTradingOrderInitialMasterUpdateReset = other.SocialTradingOrderInitialMasterUpdateReset
    } else {
      this.SocialTradingOrderInitialMasterUpdateReset = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderUpdate}
   * @returns {!OrderUpdate} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderUpdateModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderUpdateModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderUpdate}
   * @param {!OrderUpdate} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderUpdate)) {
      throw new TypeError('Instance of OrderUpdate is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderUpdate}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Key: ((this.Key != null) ? this.Key.toNumber() : null),
      ParentOrderId: ((this.ParentOrderId != null) ? this.ParentOrderId.toNumber() : null),
      ParentOrderIdReset: ((this.ParentOrderIdReset != null) ? this.ParentOrderIdReset : null),
      ActualVersion: ((this.ActualVersion != null) ? this.ActualVersion.toNumber() : null),
      SymbolId: ((this.SymbolId != null) ? this.SymbolId.toString() : null),
      OrderSide: ((this.OrderSide != null) ? this.OrderSide : null),
      OrderType: ((this.OrderType != null) ? this.OrderType : null),
      OrderInitialType: ((this.OrderInitialType != null) ? this.OrderInitialType : null),
      OrderTimeInForce: ((this.OrderTimeInForce != null) ? this.OrderTimeInForce : null),
      OrderTimeInForceReset: ((this.OrderTimeInForceReset != null) ? this.OrderTimeInForceReset : null),
      OrderStatus: ((this.OrderStatus != null) ? this.OrderStatus : null),
      Price: ((this.Price != null) ? this.Price : null),
      PriceReset: ((this.PriceReset != null) ? this.PriceReset : null),
      StopPrice: ((this.StopPrice != null) ? this.StopPrice : null),
      StopPriceReset: ((this.StopPriceReset != null) ? this.StopPriceReset : null),
      TakeProfit: ((this.TakeProfit != null) ? this.TakeProfit : null),
      TakeProfitReset: ((this.TakeProfitReset != null) ? this.TakeProfitReset : null),
      StopLoss: ((this.StopLoss != null) ? this.StopLoss : null),
      StopLossReset: ((this.StopLossReset != null) ? this.StopLossReset : null),
      Amount: ((this.Amount != null) ? this.Amount : null),
      ExecutedAmount: ((this.ExecutedAmount != null) ? this.ExecutedAmount : null),
      RemainingAmount: ((this.RemainingAmount != null) ? this.RemainingAmount : null),
      Expiration: ((this.Expiration != null) ? (this.Expiration.getTime() * 1000000) : null),
      ExpirationReset: ((this.ExpirationReset != null) ? this.ExpirationReset : null),
      AccountComment: ((this.AccountComment != null) ? this.AccountComment : null),
      ManagerComment: ((this.ManagerComment != null) ? this.ManagerComment : null),
      Magic: ((this.Magic != null) ? this.Magic : null),
      MagicReset: ((this.MagicReset != null) ? this.MagicReset : null),
      Created: ((this.Created != null) ? (this.Created.getTime() * 1000000) : null),
      Modified: ((this.Modified != null) ? (this.Modified.getTime() * 1000000) : null),
      Archived: ((this.Archived != null) ? (this.Archived.getTime() * 1000000) : null),
      Deleted: ((this.Deleted != null) ? (this.Deleted.getTime() * 1000000) : null),
      OpenPrice: ((this.OpenPrice != null) ? this.OpenPrice : null),
      OpenPriceReset: ((this.OpenPriceReset != null) ? this.OpenPriceReset : null),
      ClosePrice: ((this.ClosePrice != null) ? this.ClosePrice : null),
      ClosePriceReset: ((this.ClosePriceReset != null) ? this.ClosePriceReset : null),
      CloseAmount: ((this.CloseAmount != null) ? this.CloseAmount : null),
      CloseAmountReset: ((this.CloseAmountReset != null) ? this.CloseAmountReset : null),
      OpenMarginRate: ((this.OpenMarginRate != null) ? this.OpenMarginRate : null),
      OpenMarginRateReset: ((this.OpenMarginRateReset != null) ? this.OpenMarginRateReset : null),
      Commission: ((this.Commission != null) ? this.Commission : null),
      CommissionReset: ((this.CommissionReset != null) ? this.CommissionReset : null),
      SwapChange: ((this.SwapChange != null) ? this.SwapChange : null),
      SwapChangeReset: ((this.SwapChangeReset != null) ? this.SwapChangeReset : null),
      OpenMarkup: ((this.OpenMarkup != null) ? this.OpenMarkup.toNumber() : null),
      GatewayId: ((this.GatewayId != null) ? this.GatewayId.toString() : null),
      CloseProfit: ((this.CloseProfit != null) ? this.CloseProfit : null),
      CloseProfitReset: ((this.CloseProfitReset != null) ? this.CloseProfitReset : null),
      Opened: ((this.Opened != null) ? (this.Opened.getTime() * 1000000) : null),
      Closed: ((this.Closed != null) ? (this.Closed.getTime() * 1000000) : null),
      OpenAccountMargin: ((this.OpenAccountMargin != null) ? this.OpenAccountMargin : null),
      OpenAccountMarginReset: ((this.OpenAccountMarginReset != null) ? this.OpenAccountMarginReset : null),
      OpenAccountEquity: ((this.OpenAccountEquity != null) ? this.OpenAccountEquity : null),
      OpenAccountEquityReset: ((this.OpenAccountEquityReset != null) ? this.OpenAccountEquityReset : null),
      OpenAccountCredit: ((this.OpenAccountCredit != null) ? this.OpenAccountCredit : null),
      OpenAccountCreditReset: ((this.OpenAccountCreditReset != null) ? this.OpenAccountCreditReset : null),
      OpenAmount: ((this.OpenAmount != null) ? this.OpenAmount : null),
      OpenAmountReset: ((this.OpenAmountReset != null) ? this.OpenAmountReset : null),
      OrderRequestSourceType: ((this.OrderRequestSourceType != null) ? this.OrderRequestSourceType : null),
      IsCreatedViaQuickTrading: ((this.IsCreatedViaQuickTrading != null) ? this.IsCreatedViaQuickTrading : null),
      IsCreatedViaQuickTradingReset: ((this.IsCreatedViaQuickTradingReset != null) ? this.IsCreatedViaQuickTradingReset : null),
      IsCreatedViaFastTrader: ((this.IsCreatedViaFastTrader != null) ? this.IsCreatedViaFastTrader : null),
      IsCreatedViaFastTraderReset: ((this.IsCreatedViaFastTraderReset != null) ? this.IsCreatedViaFastTraderReset : null),
      SocialTradingOrderType: ((this.SocialTradingOrderType != null) ? this.SocialTradingOrderType : null),
      SocialTradingOrderInvestorUpdate: ((this.SocialTradingOrderInvestorUpdate != null) ? this.SocialTradingOrderInvestorUpdate : null),
      SocialTradingOrderInvestorUpdateReset: ((this.SocialTradingOrderInvestorUpdateReset != null) ? this.SocialTradingOrderInvestorUpdateReset : null),
      SocialTradingOrderMasterUpdate: ((this.SocialTradingOrderMasterUpdate != null) ? this.SocialTradingOrderMasterUpdate : null),
      SocialTradingOrderMasterUpdateReset: ((this.SocialTradingOrderMasterUpdateReset != null) ? this.SocialTradingOrderMasterUpdateReset : null),
      SocialTradingOrderInitialType: ((this.SocialTradingOrderInitialType != null) ? this.SocialTradingOrderInitialType : null),
      SocialTradingOrderInitialInvestorUpdate: ((this.SocialTradingOrderInitialInvestorUpdate != null) ? this.SocialTradingOrderInitialInvestorUpdate : null),
      SocialTradingOrderInitialInvestorUpdateReset: ((this.SocialTradingOrderInitialInvestorUpdateReset != null) ? this.SocialTradingOrderInitialInvestorUpdateReset : null),
      SocialTradingOrderInitialMasterUpdate: ((this.SocialTradingOrderInitialMasterUpdate != null) ? this.SocialTradingOrderInitialMasterUpdate : null),
      SocialTradingOrderInitialMasterUpdateReset: ((this.SocialTradingOrderInitialMasterUpdateReset != null) ? this.SocialTradingOrderInitialMasterUpdateReset : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderUpdate.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderUpdate} other Object value
   * @returns {!OrderUpdate} Created struct
   */
  static fromObject (other) {
    return new OrderUpdate().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderUpdate}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderUpdate.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderUpdate}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4170
  }
}

export { OrderUpdate };

/**
 * Fast Binary Encoding OrderUpdate field model
 */
class FieldModelOrderUpdate extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Key = new fbe.FieldModelUInt64(buffer, 4 + 4)
    this.ParentOrderId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.Key.fbeOffset + this.Key.fbeSize), buffer, this.Key.fbeOffset + this.Key.fbeSize)
    this.ParentOrderIdReset = new fbe.FieldModelBool(buffer, this.ParentOrderId.fbeOffset + this.ParentOrderId.fbeSize)
    this.ActualVersion = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.ParentOrderIdReset.fbeOffset + this.ParentOrderIdReset.fbeSize), buffer, this.ParentOrderIdReset.fbeOffset + this.ParentOrderIdReset.fbeSize)
    this.SymbolId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.ActualVersion.fbeOffset + this.ActualVersion.fbeSize), buffer, this.ActualVersion.fbeOffset + this.ActualVersion.fbeSize)
    this.OrderSide = new fbe.FieldModelOptional(new FieldModelOrderSide(buffer, this.SymbolId.fbeOffset + this.SymbolId.fbeSize), buffer, this.SymbolId.fbeOffset + this.SymbolId.fbeSize)
    this.OrderType = new fbe.FieldModelOptional(new FieldModelOrderType(buffer, this.OrderSide.fbeOffset + this.OrderSide.fbeSize), buffer, this.OrderSide.fbeOffset + this.OrderSide.fbeSize)
    this.OrderInitialType = new fbe.FieldModelOptional(new FieldModelOrderType(buffer, this.OrderType.fbeOffset + this.OrderType.fbeSize), buffer, this.OrderType.fbeOffset + this.OrderType.fbeSize)
    this.OrderTimeInForce = new fbe.FieldModelOptional(new FieldModelOrderTimeInForce(buffer, this.OrderInitialType.fbeOffset + this.OrderInitialType.fbeSize), buffer, this.OrderInitialType.fbeOffset + this.OrderInitialType.fbeSize)
    this.OrderTimeInForceReset = new fbe.FieldModelBool(buffer, this.OrderTimeInForce.fbeOffset + this.OrderTimeInForce.fbeSize)
    this.OrderStatus = new fbe.FieldModelOptional(new FieldModelOrderStatus(buffer, this.OrderTimeInForceReset.fbeOffset + this.OrderTimeInForceReset.fbeSize), buffer, this.OrderTimeInForceReset.fbeOffset + this.OrderTimeInForceReset.fbeSize)
    this.Price = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OrderStatus.fbeOffset + this.OrderStatus.fbeSize), buffer, this.OrderStatus.fbeOffset + this.OrderStatus.fbeSize)
    this.PriceReset = new fbe.FieldModelBool(buffer, this.Price.fbeOffset + this.Price.fbeSize)
    this.StopPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.PriceReset.fbeOffset + this.PriceReset.fbeSize), buffer, this.PriceReset.fbeOffset + this.PriceReset.fbeSize)
    this.StopPriceReset = new fbe.FieldModelBool(buffer, this.StopPrice.fbeOffset + this.StopPrice.fbeSize)
    this.TakeProfit = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.StopPriceReset.fbeOffset + this.StopPriceReset.fbeSize), buffer, this.StopPriceReset.fbeOffset + this.StopPriceReset.fbeSize)
    this.TakeProfitReset = new fbe.FieldModelBool(buffer, this.TakeProfit.fbeOffset + this.TakeProfit.fbeSize)
    this.StopLoss = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.TakeProfitReset.fbeOffset + this.TakeProfitReset.fbeSize), buffer, this.TakeProfitReset.fbeOffset + this.TakeProfitReset.fbeSize)
    this.StopLossReset = new fbe.FieldModelBool(buffer, this.StopLoss.fbeOffset + this.StopLoss.fbeSize)
    this.Amount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.StopLossReset.fbeOffset + this.StopLossReset.fbeSize), buffer, this.StopLossReset.fbeOffset + this.StopLossReset.fbeSize)
    this.ExecutedAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.Amount.fbeOffset + this.Amount.fbeSize), buffer, this.Amount.fbeOffset + this.Amount.fbeSize)
    this.RemainingAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ExecutedAmount.fbeOffset + this.ExecutedAmount.fbeSize), buffer, this.ExecutedAmount.fbeOffset + this.ExecutedAmount.fbeSize)
    this.Expiration = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.RemainingAmount.fbeOffset + this.RemainingAmount.fbeSize), buffer, this.RemainingAmount.fbeOffset + this.RemainingAmount.fbeSize)
    this.ExpirationReset = new fbe.FieldModelBool(buffer, this.Expiration.fbeOffset + this.Expiration.fbeSize)
    this.AccountComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.ExpirationReset.fbeOffset + this.ExpirationReset.fbeSize), buffer, this.ExpirationReset.fbeOffset + this.ExpirationReset.fbeSize)
    this.ManagerComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.AccountComment.fbeOffset + this.AccountComment.fbeSize), buffer, this.AccountComment.fbeOffset + this.AccountComment.fbeSize)
    this.Magic = new fbe.FieldModelOptional(new fbe.FieldModelInt32(buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize), buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize)
    this.MagicReset = new fbe.FieldModelBool(buffer, this.Magic.fbeOffset + this.Magic.fbeSize)
    this.Created = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.MagicReset.fbeOffset + this.MagicReset.fbeSize), buffer, this.MagicReset.fbeOffset + this.MagicReset.fbeSize)
    this.Modified = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.Created.fbeOffset + this.Created.fbeSize), buffer, this.Created.fbeOffset + this.Created.fbeSize)
    this.Archived = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.Modified.fbeOffset + this.Modified.fbeSize), buffer, this.Modified.fbeOffset + this.Modified.fbeSize)
    this.Deleted = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.Archived.fbeOffset + this.Archived.fbeSize), buffer, this.Archived.fbeOffset + this.Archived.fbeSize)
    this.OpenPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.Deleted.fbeOffset + this.Deleted.fbeSize), buffer, this.Deleted.fbeOffset + this.Deleted.fbeSize)
    this.OpenPriceReset = new fbe.FieldModelBool(buffer, this.OpenPrice.fbeOffset + this.OpenPrice.fbeSize)
    this.ClosePrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenPriceReset.fbeOffset + this.OpenPriceReset.fbeSize), buffer, this.OpenPriceReset.fbeOffset + this.OpenPriceReset.fbeSize)
    this.ClosePriceReset = new fbe.FieldModelBool(buffer, this.ClosePrice.fbeOffset + this.ClosePrice.fbeSize)
    this.CloseAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ClosePriceReset.fbeOffset + this.ClosePriceReset.fbeSize), buffer, this.ClosePriceReset.fbeOffset + this.ClosePriceReset.fbeSize)
    this.CloseAmountReset = new fbe.FieldModelBool(buffer, this.CloseAmount.fbeOffset + this.CloseAmount.fbeSize)
    this.OpenMarginRate = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.CloseAmountReset.fbeOffset + this.CloseAmountReset.fbeSize), buffer, this.CloseAmountReset.fbeOffset + this.CloseAmountReset.fbeSize)
    this.OpenMarginRateReset = new fbe.FieldModelBool(buffer, this.OpenMarginRate.fbeOffset + this.OpenMarginRate.fbeSize)
    this.Commission = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenMarginRateReset.fbeOffset + this.OpenMarginRateReset.fbeSize), buffer, this.OpenMarginRateReset.fbeOffset + this.OpenMarginRateReset.fbeSize)
    this.CommissionReset = new fbe.FieldModelBool(buffer, this.Commission.fbeOffset + this.Commission.fbeSize)
    this.SwapChange = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.CommissionReset.fbeOffset + this.CommissionReset.fbeSize), buffer, this.CommissionReset.fbeOffset + this.CommissionReset.fbeSize)
    this.SwapChangeReset = new fbe.FieldModelBool(buffer, this.SwapChange.fbeOffset + this.SwapChange.fbeSize)
    this.OpenMarkup = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.SwapChangeReset.fbeOffset + this.SwapChangeReset.fbeSize), buffer, this.SwapChangeReset.fbeOffset + this.SwapChangeReset.fbeSize)
    this.GatewayId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.OpenMarkup.fbeOffset + this.OpenMarkup.fbeSize), buffer, this.OpenMarkup.fbeOffset + this.OpenMarkup.fbeSize)
    this.CloseProfit = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.GatewayId.fbeOffset + this.GatewayId.fbeSize), buffer, this.GatewayId.fbeOffset + this.GatewayId.fbeSize)
    this.CloseProfitReset = new fbe.FieldModelBool(buffer, this.CloseProfit.fbeOffset + this.CloseProfit.fbeSize)
    this.Opened = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.CloseProfitReset.fbeOffset + this.CloseProfitReset.fbeSize), buffer, this.CloseProfitReset.fbeOffset + this.CloseProfitReset.fbeSize)
    this.Closed = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.Opened.fbeOffset + this.Opened.fbeSize), buffer, this.Opened.fbeOffset + this.Opened.fbeSize)
    this.OpenAccountMargin = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.Closed.fbeOffset + this.Closed.fbeSize), buffer, this.Closed.fbeOffset + this.Closed.fbeSize)
    this.OpenAccountMarginReset = new fbe.FieldModelBool(buffer, this.OpenAccountMargin.fbeOffset + this.OpenAccountMargin.fbeSize)
    this.OpenAccountEquity = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenAccountMarginReset.fbeOffset + this.OpenAccountMarginReset.fbeSize), buffer, this.OpenAccountMarginReset.fbeOffset + this.OpenAccountMarginReset.fbeSize)
    this.OpenAccountEquityReset = new fbe.FieldModelBool(buffer, this.OpenAccountEquity.fbeOffset + this.OpenAccountEquity.fbeSize)
    this.OpenAccountCredit = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenAccountEquityReset.fbeOffset + this.OpenAccountEquityReset.fbeSize), buffer, this.OpenAccountEquityReset.fbeOffset + this.OpenAccountEquityReset.fbeSize)
    this.OpenAccountCreditReset = new fbe.FieldModelBool(buffer, this.OpenAccountCredit.fbeOffset + this.OpenAccountCredit.fbeSize)
    this.OpenAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.OpenAccountCreditReset.fbeOffset + this.OpenAccountCreditReset.fbeSize), buffer, this.OpenAccountCreditReset.fbeOffset + this.OpenAccountCreditReset.fbeSize)
    this.OpenAmountReset = new fbe.FieldModelBool(buffer, this.OpenAmount.fbeOffset + this.OpenAmount.fbeSize)
    this.OrderRequestSourceType = new fbe.FieldModelOptional(new FieldModelOrderRequestSourceType(buffer, this.OpenAmountReset.fbeOffset + this.OpenAmountReset.fbeSize), buffer, this.OpenAmountReset.fbeOffset + this.OpenAmountReset.fbeSize)
    this.IsCreatedViaQuickTrading = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.OrderRequestSourceType.fbeOffset + this.OrderRequestSourceType.fbeSize), buffer, this.OrderRequestSourceType.fbeOffset + this.OrderRequestSourceType.fbeSize)
    this.IsCreatedViaQuickTradingReset = new fbe.FieldModelBool(buffer, this.IsCreatedViaQuickTrading.fbeOffset + this.IsCreatedViaQuickTrading.fbeSize)
    this.IsCreatedViaFastTrader = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.IsCreatedViaQuickTradingReset.fbeOffset + this.IsCreatedViaQuickTradingReset.fbeSize), buffer, this.IsCreatedViaQuickTradingReset.fbeOffset + this.IsCreatedViaQuickTradingReset.fbeSize)
    this.IsCreatedViaFastTraderReset = new fbe.FieldModelBool(buffer, this.IsCreatedViaFastTrader.fbeOffset + this.IsCreatedViaFastTrader.fbeSize)
    this.SocialTradingOrderType = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderType(buffer, this.IsCreatedViaFastTraderReset.fbeOffset + this.IsCreatedViaFastTraderReset.fbeSize), buffer, this.IsCreatedViaFastTraderReset.fbeOffset + this.IsCreatedViaFastTraderReset.fbeSize)
    this.SocialTradingOrderInvestorUpdate = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderInvestorUpdate(buffer, this.SocialTradingOrderType.fbeOffset + this.SocialTradingOrderType.fbeSize), buffer, this.SocialTradingOrderType.fbeOffset + this.SocialTradingOrderType.fbeSize)
    this.SocialTradingOrderInvestorUpdateReset = new fbe.FieldModelBool(buffer, this.SocialTradingOrderInvestorUpdate.fbeOffset + this.SocialTradingOrderInvestorUpdate.fbeSize)
    this.SocialTradingOrderMasterUpdate = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderMasterUpdate(buffer, this.SocialTradingOrderInvestorUpdateReset.fbeOffset + this.SocialTradingOrderInvestorUpdateReset.fbeSize), buffer, this.SocialTradingOrderInvestorUpdateReset.fbeOffset + this.SocialTradingOrderInvestorUpdateReset.fbeSize)
    this.SocialTradingOrderMasterUpdateReset = new fbe.FieldModelBool(buffer, this.SocialTradingOrderMasterUpdate.fbeOffset + this.SocialTradingOrderMasterUpdate.fbeSize)
    this.SocialTradingOrderInitialType = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderType(buffer, this.SocialTradingOrderMasterUpdateReset.fbeOffset + this.SocialTradingOrderMasterUpdateReset.fbeSize), buffer, this.SocialTradingOrderMasterUpdateReset.fbeOffset + this.SocialTradingOrderMasterUpdateReset.fbeSize)
    this.SocialTradingOrderInitialInvestorUpdate = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderInvestorUpdate(buffer, this.SocialTradingOrderInitialType.fbeOffset + this.SocialTradingOrderInitialType.fbeSize), buffer, this.SocialTradingOrderInitialType.fbeOffset + this.SocialTradingOrderInitialType.fbeSize)
    this.SocialTradingOrderInitialInvestorUpdateReset = new fbe.FieldModelBool(buffer, this.SocialTradingOrderInitialInvestorUpdate.fbeOffset + this.SocialTradingOrderInitialInvestorUpdate.fbeSize)
    this.SocialTradingOrderInitialMasterUpdate = new fbe.FieldModelOptional(new FieldModelSocialTradingOrderMasterUpdate(buffer, this.SocialTradingOrderInitialInvestorUpdateReset.fbeOffset + this.SocialTradingOrderInitialInvestorUpdateReset.fbeSize), buffer, this.SocialTradingOrderInitialInvestorUpdateReset.fbeOffset + this.SocialTradingOrderInitialInvestorUpdateReset.fbeSize)
    this.SocialTradingOrderInitialMasterUpdateReset = new fbe.FieldModelBool(buffer, this.SocialTradingOrderInitialMasterUpdate.fbeOffset + this.SocialTradingOrderInitialMasterUpdate.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderUpdate}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderUpdate}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Key.fbeSize + this.ParentOrderId.fbeSize + this.ParentOrderIdReset.fbeSize + this.ActualVersion.fbeSize + this.SymbolId.fbeSize + this.OrderSide.fbeSize + this.OrderType.fbeSize + this.OrderInitialType.fbeSize + this.OrderTimeInForce.fbeSize + this.OrderTimeInForceReset.fbeSize + this.OrderStatus.fbeSize + this.Price.fbeSize + this.PriceReset.fbeSize + this.StopPrice.fbeSize + this.StopPriceReset.fbeSize + this.TakeProfit.fbeSize + this.TakeProfitReset.fbeSize + this.StopLoss.fbeSize + this.StopLossReset.fbeSize + this.Amount.fbeSize + this.ExecutedAmount.fbeSize + this.RemainingAmount.fbeSize + this.Expiration.fbeSize + this.ExpirationReset.fbeSize + this.AccountComment.fbeSize + this.ManagerComment.fbeSize + this.Magic.fbeSize + this.MagicReset.fbeSize + this.Created.fbeSize + this.Modified.fbeSize + this.Archived.fbeSize + this.Deleted.fbeSize + this.OpenPrice.fbeSize + this.OpenPriceReset.fbeSize + this.ClosePrice.fbeSize + this.ClosePriceReset.fbeSize + this.CloseAmount.fbeSize + this.CloseAmountReset.fbeSize + this.OpenMarginRate.fbeSize + this.OpenMarginRateReset.fbeSize + this.Commission.fbeSize + this.CommissionReset.fbeSize + this.SwapChange.fbeSize + this.SwapChangeReset.fbeSize + this.OpenMarkup.fbeSize + this.GatewayId.fbeSize + this.CloseProfit.fbeSize + this.CloseProfitReset.fbeSize + this.Opened.fbeSize + this.Closed.fbeSize + this.OpenAccountMargin.fbeSize + this.OpenAccountMarginReset.fbeSize + this.OpenAccountEquity.fbeSize + this.OpenAccountEquityReset.fbeSize + this.OpenAccountCredit.fbeSize + this.OpenAccountCreditReset.fbeSize + this.OpenAmount.fbeSize + this.OpenAmountReset.fbeSize + this.OrderRequestSourceType.fbeSize + this.IsCreatedViaQuickTrading.fbeSize + this.IsCreatedViaQuickTradingReset.fbeSize + this.IsCreatedViaFastTrader.fbeSize + this.IsCreatedViaFastTraderReset.fbeSize + this.SocialTradingOrderType.fbeSize + this.SocialTradingOrderInvestorUpdate.fbeSize + this.SocialTradingOrderInvestorUpdateReset.fbeSize + this.SocialTradingOrderMasterUpdate.fbeSize + this.SocialTradingOrderMasterUpdateReset.fbeSize + this.SocialTradingOrderInitialType.fbeSize + this.SocialTradingOrderInitialInvestorUpdate.fbeSize + this.SocialTradingOrderInitialInvestorUpdateReset.fbeSize + this.SocialTradingOrderInitialMasterUpdate.fbeSize + this.SocialTradingOrderInitialMasterUpdateReset.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderUpdate}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Key.fbeExtra + this.ParentOrderId.fbeExtra + this.ParentOrderIdReset.fbeExtra + this.ActualVersion.fbeExtra + this.SymbolId.fbeExtra + this.OrderSide.fbeExtra + this.OrderType.fbeExtra + this.OrderInitialType.fbeExtra + this.OrderTimeInForce.fbeExtra + this.OrderTimeInForceReset.fbeExtra + this.OrderStatus.fbeExtra + this.Price.fbeExtra + this.PriceReset.fbeExtra + this.StopPrice.fbeExtra + this.StopPriceReset.fbeExtra + this.TakeProfit.fbeExtra + this.TakeProfitReset.fbeExtra + this.StopLoss.fbeExtra + this.StopLossReset.fbeExtra + this.Amount.fbeExtra + this.ExecutedAmount.fbeExtra + this.RemainingAmount.fbeExtra + this.Expiration.fbeExtra + this.ExpirationReset.fbeExtra + this.AccountComment.fbeExtra + this.ManagerComment.fbeExtra + this.Magic.fbeExtra + this.MagicReset.fbeExtra + this.Created.fbeExtra + this.Modified.fbeExtra + this.Archived.fbeExtra + this.Deleted.fbeExtra + this.OpenPrice.fbeExtra + this.OpenPriceReset.fbeExtra + this.ClosePrice.fbeExtra + this.ClosePriceReset.fbeExtra + this.CloseAmount.fbeExtra + this.CloseAmountReset.fbeExtra + this.OpenMarginRate.fbeExtra + this.OpenMarginRateReset.fbeExtra + this.Commission.fbeExtra + this.CommissionReset.fbeExtra + this.SwapChange.fbeExtra + this.SwapChangeReset.fbeExtra + this.OpenMarkup.fbeExtra + this.GatewayId.fbeExtra + this.CloseProfit.fbeExtra + this.CloseProfitReset.fbeExtra + this.Opened.fbeExtra + this.Closed.fbeExtra + this.OpenAccountMargin.fbeExtra + this.OpenAccountMarginReset.fbeExtra + this.OpenAccountEquity.fbeExtra + this.OpenAccountEquityReset.fbeExtra + this.OpenAccountCredit.fbeExtra + this.OpenAccountCreditReset.fbeExtra + this.OpenAmount.fbeExtra + this.OpenAmountReset.fbeExtra + this.OrderRequestSourceType.fbeExtra + this.IsCreatedViaQuickTrading.fbeExtra + this.IsCreatedViaQuickTradingReset.fbeExtra + this.IsCreatedViaFastTrader.fbeExtra + this.IsCreatedViaFastTraderReset.fbeExtra + this.SocialTradingOrderType.fbeExtra + this.SocialTradingOrderInvestorUpdate.fbeExtra + this.SocialTradingOrderInvestorUpdateReset.fbeExtra + this.SocialTradingOrderMasterUpdate.fbeExtra + this.SocialTradingOrderMasterUpdateReset.fbeExtra + this.SocialTradingOrderInitialType.fbeExtra + this.SocialTradingOrderInitialInvestorUpdate.fbeExtra + this.SocialTradingOrderInitialInvestorUpdateReset.fbeExtra + this.SocialTradingOrderInitialMasterUpdate.fbeExtra + this.SocialTradingOrderInitialMasterUpdateReset.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderUpdate}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderUpdate.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderUpdate}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4170
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderUpdate}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderUpdate}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Key.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Key.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Key.fbeSize

    if ((fbeCurrentSize + this.ParentOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ParentOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ParentOrderId.fbeSize

    if ((fbeCurrentSize + this.ParentOrderIdReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ParentOrderIdReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ParentOrderIdReset.fbeSize

    if ((fbeCurrentSize + this.ActualVersion.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ActualVersion.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActualVersion.fbeSize

    if ((fbeCurrentSize + this.SymbolId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolId.fbeSize

    if ((fbeCurrentSize + this.OrderSide.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderSide.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderSide.fbeSize

    if ((fbeCurrentSize + this.OrderType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderType.fbeSize

    if ((fbeCurrentSize + this.OrderInitialType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderInitialType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderInitialType.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForce.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderTimeInForce.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForce.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForceReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderTimeInForceReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForceReset.fbeSize

    if ((fbeCurrentSize + this.OrderStatus.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderStatus.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStatus.fbeSize

    if ((fbeCurrentSize + this.Price.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Price.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Price.fbeSize

    if ((fbeCurrentSize + this.PriceReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PriceReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PriceReset.fbeSize

    if ((fbeCurrentSize + this.StopPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopPrice.fbeSize

    if ((fbeCurrentSize + this.StopPriceReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopPriceReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopPriceReset.fbeSize

    if ((fbeCurrentSize + this.TakeProfit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TakeProfit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TakeProfit.fbeSize

    if ((fbeCurrentSize + this.TakeProfitReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TakeProfitReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TakeProfitReset.fbeSize

    if ((fbeCurrentSize + this.StopLoss.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopLoss.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopLoss.fbeSize

    if ((fbeCurrentSize + this.StopLossReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StopLossReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopLossReset.fbeSize

    if ((fbeCurrentSize + this.Amount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Amount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Amount.fbeSize

    if ((fbeCurrentSize + this.ExecutedAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExecutedAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExecutedAmount.fbeSize

    if ((fbeCurrentSize + this.RemainingAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RemainingAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RemainingAmount.fbeSize

    if ((fbeCurrentSize + this.Expiration.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Expiration.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Expiration.fbeSize

    if ((fbeCurrentSize + this.ExpirationReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExpirationReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExpirationReset.fbeSize

    if ((fbeCurrentSize + this.AccountComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountComment.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.Magic.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Magic.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Magic.fbeSize

    if ((fbeCurrentSize + this.MagicReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MagicReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MagicReset.fbeSize

    if ((fbeCurrentSize + this.Created.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Created.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Created.fbeSize

    if ((fbeCurrentSize + this.Modified.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Modified.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Modified.fbeSize

    if ((fbeCurrentSize + this.Archived.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Archived.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Archived.fbeSize

    if ((fbeCurrentSize + this.Deleted.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Deleted.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deleted.fbeSize

    if ((fbeCurrentSize + this.OpenPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenPrice.fbeSize

    if ((fbeCurrentSize + this.OpenPriceReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenPriceReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenPriceReset.fbeSize

    if ((fbeCurrentSize + this.ClosePrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClosePrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePrice.fbeSize

    if ((fbeCurrentSize + this.ClosePriceReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClosePriceReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePriceReset.fbeSize

    if ((fbeCurrentSize + this.CloseAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmount.fbeSize

    if ((fbeCurrentSize + this.CloseAmountReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseAmountReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmountReset.fbeSize

    if ((fbeCurrentSize + this.OpenMarginRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenMarginRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarginRate.fbeSize

    if ((fbeCurrentSize + this.OpenMarginRateReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenMarginRateReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarginRateReset.fbeSize

    if ((fbeCurrentSize + this.Commission.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Commission.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Commission.fbeSize

    if ((fbeCurrentSize + this.CommissionReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionReset.fbeSize

    if ((fbeCurrentSize + this.SwapChange.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SwapChange.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SwapChange.fbeSize

    if ((fbeCurrentSize + this.SwapChangeReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SwapChangeReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SwapChangeReset.fbeSize

    if ((fbeCurrentSize + this.OpenMarkup.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenMarkup.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarkup.fbeSize

    if ((fbeCurrentSize + this.GatewayId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GatewayId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayId.fbeSize

    if ((fbeCurrentSize + this.CloseProfit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseProfit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseProfit.fbeSize

    if ((fbeCurrentSize + this.CloseProfitReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseProfitReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseProfitReset.fbeSize

    if ((fbeCurrentSize + this.Opened.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Opened.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Opened.fbeSize

    if ((fbeCurrentSize + this.Closed.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Closed.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Closed.fbeSize

    if ((fbeCurrentSize + this.OpenAccountMargin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountMargin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountMargin.fbeSize

    if ((fbeCurrentSize + this.OpenAccountMarginReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountMarginReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountMarginReset.fbeSize

    if ((fbeCurrentSize + this.OpenAccountEquity.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountEquity.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountEquity.fbeSize

    if ((fbeCurrentSize + this.OpenAccountEquityReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountEquityReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountEquityReset.fbeSize

    if ((fbeCurrentSize + this.OpenAccountCredit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountCredit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountCredit.fbeSize

    if ((fbeCurrentSize + this.OpenAccountCreditReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAccountCreditReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountCreditReset.fbeSize

    if ((fbeCurrentSize + this.OpenAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAmount.fbeSize

    if ((fbeCurrentSize + this.OpenAmountReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OpenAmountReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAmountReset.fbeSize

    if ((fbeCurrentSize + this.OrderRequestSourceType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderRequestSourceType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderRequestSourceType.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaQuickTrading.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsCreatedViaQuickTrading.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaQuickTrading.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaQuickTradingReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsCreatedViaQuickTradingReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaQuickTradingReset.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaFastTrader.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsCreatedViaFastTrader.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaFastTrader.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaFastTraderReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsCreatedViaFastTraderReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaFastTraderReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInvestorUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInvestorUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInvestorUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInvestorUpdateReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInvestorUpdateReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInvestorUpdateReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderMasterUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderMasterUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderMasterUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderMasterUpdateReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderMasterUpdateReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderMasterUpdateReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInitialType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialInvestorUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInitialInvestorUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialInvestorUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialInvestorUpdateReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInitialInvestorUpdateReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialInvestorUpdateReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialMasterUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInitialMasterUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialMasterUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialMasterUpdateReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingOrderInitialMasterUpdateReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialMasterUpdateReset.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderUpdate}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderUpdate}
   * @param {!OrderUpdate} fbeValue Default value, defaults is new OrderUpdate()
   * @returns {!OrderUpdate} OrderUpdate value
   */
  get (fbeValue = new OrderUpdate()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderUpdate}
   * @param {!OrderUpdate} fbeValue OrderUpdate value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Key.fbeSize) <= fbeStructSize) {
      fbeValue.Key = this.Key.get()
    } else {
      fbeValue.Key = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Key.fbeSize

    if ((fbeCurrentSize + this.ParentOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.ParentOrderId = this.ParentOrderId.get()
    } else {
      fbeValue.ParentOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ParentOrderId.fbeSize

    if ((fbeCurrentSize + this.ParentOrderIdReset.fbeSize) <= fbeStructSize) {
      fbeValue.ParentOrderIdReset = this.ParentOrderIdReset.get()
    } else {
      fbeValue.ParentOrderIdReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ParentOrderIdReset.fbeSize

    if ((fbeCurrentSize + this.ActualVersion.fbeSize) <= fbeStructSize) {
      fbeValue.ActualVersion = this.ActualVersion.get()
    } else {
      fbeValue.ActualVersion = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActualVersion.fbeSize

    if ((fbeCurrentSize + this.SymbolId.fbeSize) <= fbeStructSize) {
      fbeValue.SymbolId = this.SymbolId.get()
    } else {
      fbeValue.SymbolId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolId.fbeSize

    if ((fbeCurrentSize + this.OrderSide.fbeSize) <= fbeStructSize) {
      fbeValue.OrderSide = this.OrderSide.get()
    } else {
      fbeValue.OrderSide = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderSide.fbeSize

    if ((fbeCurrentSize + this.OrderType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderType = this.OrderType.get()
    } else {
      fbeValue.OrderType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderType.fbeSize

    if ((fbeCurrentSize + this.OrderInitialType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderInitialType = this.OrderInitialType.get()
    } else {
      fbeValue.OrderInitialType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderInitialType.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForce.fbeSize) <= fbeStructSize) {
      fbeValue.OrderTimeInForce = this.OrderTimeInForce.get()
    } else {
      fbeValue.OrderTimeInForce = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForce.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForceReset.fbeSize) <= fbeStructSize) {
      fbeValue.OrderTimeInForceReset = this.OrderTimeInForceReset.get()
    } else {
      fbeValue.OrderTimeInForceReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForceReset.fbeSize

    if ((fbeCurrentSize + this.OrderStatus.fbeSize) <= fbeStructSize) {
      fbeValue.OrderStatus = this.OrderStatus.get()
    } else {
      fbeValue.OrderStatus = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStatus.fbeSize

    if ((fbeCurrentSize + this.Price.fbeSize) <= fbeStructSize) {
      fbeValue.Price = this.Price.get()
    } else {
      fbeValue.Price = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Price.fbeSize

    if ((fbeCurrentSize + this.PriceReset.fbeSize) <= fbeStructSize) {
      fbeValue.PriceReset = this.PriceReset.get()
    } else {
      fbeValue.PriceReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PriceReset.fbeSize

    if ((fbeCurrentSize + this.StopPrice.fbeSize) <= fbeStructSize) {
      fbeValue.StopPrice = this.StopPrice.get()
    } else {
      fbeValue.StopPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopPrice.fbeSize

    if ((fbeCurrentSize + this.StopPriceReset.fbeSize) <= fbeStructSize) {
      fbeValue.StopPriceReset = this.StopPriceReset.get()
    } else {
      fbeValue.StopPriceReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopPriceReset.fbeSize

    if ((fbeCurrentSize + this.TakeProfit.fbeSize) <= fbeStructSize) {
      fbeValue.TakeProfit = this.TakeProfit.get()
    } else {
      fbeValue.TakeProfit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TakeProfit.fbeSize

    if ((fbeCurrentSize + this.TakeProfitReset.fbeSize) <= fbeStructSize) {
      fbeValue.TakeProfitReset = this.TakeProfitReset.get()
    } else {
      fbeValue.TakeProfitReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TakeProfitReset.fbeSize

    if ((fbeCurrentSize + this.StopLoss.fbeSize) <= fbeStructSize) {
      fbeValue.StopLoss = this.StopLoss.get()
    } else {
      fbeValue.StopLoss = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopLoss.fbeSize

    if ((fbeCurrentSize + this.StopLossReset.fbeSize) <= fbeStructSize) {
      fbeValue.StopLossReset = this.StopLossReset.get()
    } else {
      fbeValue.StopLossReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StopLossReset.fbeSize

    if ((fbeCurrentSize + this.Amount.fbeSize) <= fbeStructSize) {
      fbeValue.Amount = this.Amount.get()
    } else {
      fbeValue.Amount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Amount.fbeSize

    if ((fbeCurrentSize + this.ExecutedAmount.fbeSize) <= fbeStructSize) {
      fbeValue.ExecutedAmount = this.ExecutedAmount.get()
    } else {
      fbeValue.ExecutedAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExecutedAmount.fbeSize

    if ((fbeCurrentSize + this.RemainingAmount.fbeSize) <= fbeStructSize) {
      fbeValue.RemainingAmount = this.RemainingAmount.get()
    } else {
      fbeValue.RemainingAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RemainingAmount.fbeSize

    if ((fbeCurrentSize + this.Expiration.fbeSize) <= fbeStructSize) {
      fbeValue.Expiration = this.Expiration.get()
    } else {
      fbeValue.Expiration = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Expiration.fbeSize

    if ((fbeCurrentSize + this.ExpirationReset.fbeSize) <= fbeStructSize) {
      fbeValue.ExpirationReset = this.ExpirationReset.get()
    } else {
      fbeValue.ExpirationReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExpirationReset.fbeSize

    if ((fbeCurrentSize + this.AccountComment.fbeSize) <= fbeStructSize) {
      fbeValue.AccountComment = this.AccountComment.get()
    } else {
      fbeValue.AccountComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountComment.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerComment = this.ManagerComment.get()
    } else {
      fbeValue.ManagerComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.Magic.fbeSize) <= fbeStructSize) {
      fbeValue.Magic = this.Magic.get()
    } else {
      fbeValue.Magic = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Magic.fbeSize

    if ((fbeCurrentSize + this.MagicReset.fbeSize) <= fbeStructSize) {
      fbeValue.MagicReset = this.MagicReset.get()
    } else {
      fbeValue.MagicReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MagicReset.fbeSize

    if ((fbeCurrentSize + this.Created.fbeSize) <= fbeStructSize) {
      fbeValue.Created = this.Created.get()
    } else {
      fbeValue.Created = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Created.fbeSize

    if ((fbeCurrentSize + this.Modified.fbeSize) <= fbeStructSize) {
      fbeValue.Modified = this.Modified.get()
    } else {
      fbeValue.Modified = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Modified.fbeSize

    if ((fbeCurrentSize + this.Archived.fbeSize) <= fbeStructSize) {
      fbeValue.Archived = this.Archived.get()
    } else {
      fbeValue.Archived = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Archived.fbeSize

    if ((fbeCurrentSize + this.Deleted.fbeSize) <= fbeStructSize) {
      fbeValue.Deleted = this.Deleted.get()
    } else {
      fbeValue.Deleted = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deleted.fbeSize

    if ((fbeCurrentSize + this.OpenPrice.fbeSize) <= fbeStructSize) {
      fbeValue.OpenPrice = this.OpenPrice.get()
    } else {
      fbeValue.OpenPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenPrice.fbeSize

    if ((fbeCurrentSize + this.OpenPriceReset.fbeSize) <= fbeStructSize) {
      fbeValue.OpenPriceReset = this.OpenPriceReset.get()
    } else {
      fbeValue.OpenPriceReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenPriceReset.fbeSize

    if ((fbeCurrentSize + this.ClosePrice.fbeSize) <= fbeStructSize) {
      fbeValue.ClosePrice = this.ClosePrice.get()
    } else {
      fbeValue.ClosePrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePrice.fbeSize

    if ((fbeCurrentSize + this.ClosePriceReset.fbeSize) <= fbeStructSize) {
      fbeValue.ClosePriceReset = this.ClosePriceReset.get()
    } else {
      fbeValue.ClosePriceReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosePriceReset.fbeSize

    if ((fbeCurrentSize + this.CloseAmount.fbeSize) <= fbeStructSize) {
      fbeValue.CloseAmount = this.CloseAmount.get()
    } else {
      fbeValue.CloseAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmount.fbeSize

    if ((fbeCurrentSize + this.CloseAmountReset.fbeSize) <= fbeStructSize) {
      fbeValue.CloseAmountReset = this.CloseAmountReset.get()
    } else {
      fbeValue.CloseAmountReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseAmountReset.fbeSize

    if ((fbeCurrentSize + this.OpenMarginRate.fbeSize) <= fbeStructSize) {
      fbeValue.OpenMarginRate = this.OpenMarginRate.get()
    } else {
      fbeValue.OpenMarginRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarginRate.fbeSize

    if ((fbeCurrentSize + this.OpenMarginRateReset.fbeSize) <= fbeStructSize) {
      fbeValue.OpenMarginRateReset = this.OpenMarginRateReset.get()
    } else {
      fbeValue.OpenMarginRateReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarginRateReset.fbeSize

    if ((fbeCurrentSize + this.Commission.fbeSize) <= fbeStructSize) {
      fbeValue.Commission = this.Commission.get()
    } else {
      fbeValue.Commission = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Commission.fbeSize

    if ((fbeCurrentSize + this.CommissionReset.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionReset = this.CommissionReset.get()
    } else {
      fbeValue.CommissionReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionReset.fbeSize

    if ((fbeCurrentSize + this.SwapChange.fbeSize) <= fbeStructSize) {
      fbeValue.SwapChange = this.SwapChange.get()
    } else {
      fbeValue.SwapChange = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SwapChange.fbeSize

    if ((fbeCurrentSize + this.SwapChangeReset.fbeSize) <= fbeStructSize) {
      fbeValue.SwapChangeReset = this.SwapChangeReset.get()
    } else {
      fbeValue.SwapChangeReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SwapChangeReset.fbeSize

    if ((fbeCurrentSize + this.OpenMarkup.fbeSize) <= fbeStructSize) {
      fbeValue.OpenMarkup = this.OpenMarkup.get()
    } else {
      fbeValue.OpenMarkup = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenMarkup.fbeSize

    if ((fbeCurrentSize + this.GatewayId.fbeSize) <= fbeStructSize) {
      fbeValue.GatewayId = this.GatewayId.get()
    } else {
      fbeValue.GatewayId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayId.fbeSize

    if ((fbeCurrentSize + this.CloseProfit.fbeSize) <= fbeStructSize) {
      fbeValue.CloseProfit = this.CloseProfit.get()
    } else {
      fbeValue.CloseProfit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseProfit.fbeSize

    if ((fbeCurrentSize + this.CloseProfitReset.fbeSize) <= fbeStructSize) {
      fbeValue.CloseProfitReset = this.CloseProfitReset.get()
    } else {
      fbeValue.CloseProfitReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseProfitReset.fbeSize

    if ((fbeCurrentSize + this.Opened.fbeSize) <= fbeStructSize) {
      fbeValue.Opened = this.Opened.get()
    } else {
      fbeValue.Opened = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Opened.fbeSize

    if ((fbeCurrentSize + this.Closed.fbeSize) <= fbeStructSize) {
      fbeValue.Closed = this.Closed.get()
    } else {
      fbeValue.Closed = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Closed.fbeSize

    if ((fbeCurrentSize + this.OpenAccountMargin.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountMargin = this.OpenAccountMargin.get()
    } else {
      fbeValue.OpenAccountMargin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountMargin.fbeSize

    if ((fbeCurrentSize + this.OpenAccountMarginReset.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountMarginReset = this.OpenAccountMarginReset.get()
    } else {
      fbeValue.OpenAccountMarginReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountMarginReset.fbeSize

    if ((fbeCurrentSize + this.OpenAccountEquity.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountEquity = this.OpenAccountEquity.get()
    } else {
      fbeValue.OpenAccountEquity = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountEquity.fbeSize

    if ((fbeCurrentSize + this.OpenAccountEquityReset.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountEquityReset = this.OpenAccountEquityReset.get()
    } else {
      fbeValue.OpenAccountEquityReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountEquityReset.fbeSize

    if ((fbeCurrentSize + this.OpenAccountCredit.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountCredit = this.OpenAccountCredit.get()
    } else {
      fbeValue.OpenAccountCredit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountCredit.fbeSize

    if ((fbeCurrentSize + this.OpenAccountCreditReset.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAccountCreditReset = this.OpenAccountCreditReset.get()
    } else {
      fbeValue.OpenAccountCreditReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAccountCreditReset.fbeSize

    if ((fbeCurrentSize + this.OpenAmount.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAmount = this.OpenAmount.get()
    } else {
      fbeValue.OpenAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAmount.fbeSize

    if ((fbeCurrentSize + this.OpenAmountReset.fbeSize) <= fbeStructSize) {
      fbeValue.OpenAmountReset = this.OpenAmountReset.get()
    } else {
      fbeValue.OpenAmountReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OpenAmountReset.fbeSize

    if ((fbeCurrentSize + this.OrderRequestSourceType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderRequestSourceType = this.OrderRequestSourceType.get()
    } else {
      fbeValue.OrderRequestSourceType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderRequestSourceType.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaQuickTrading.fbeSize) <= fbeStructSize) {
      fbeValue.IsCreatedViaQuickTrading = this.IsCreatedViaQuickTrading.get()
    } else {
      fbeValue.IsCreatedViaQuickTrading = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaQuickTrading.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaQuickTradingReset.fbeSize) <= fbeStructSize) {
      fbeValue.IsCreatedViaQuickTradingReset = this.IsCreatedViaQuickTradingReset.get()
    } else {
      fbeValue.IsCreatedViaQuickTradingReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaQuickTradingReset.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaFastTrader.fbeSize) <= fbeStructSize) {
      fbeValue.IsCreatedViaFastTrader = this.IsCreatedViaFastTrader.get()
    } else {
      fbeValue.IsCreatedViaFastTrader = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaFastTrader.fbeSize

    if ((fbeCurrentSize + this.IsCreatedViaFastTraderReset.fbeSize) <= fbeStructSize) {
      fbeValue.IsCreatedViaFastTraderReset = this.IsCreatedViaFastTraderReset.get()
    } else {
      fbeValue.IsCreatedViaFastTraderReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsCreatedViaFastTraderReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderType.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderType = this.SocialTradingOrderType.get()
    } else {
      fbeValue.SocialTradingOrderType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInvestorUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInvestorUpdate = this.SocialTradingOrderInvestorUpdate.get()
    } else {
      fbeValue.SocialTradingOrderInvestorUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInvestorUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInvestorUpdateReset.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInvestorUpdateReset = this.SocialTradingOrderInvestorUpdateReset.get()
    } else {
      fbeValue.SocialTradingOrderInvestorUpdateReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInvestorUpdateReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderMasterUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderMasterUpdate = this.SocialTradingOrderMasterUpdate.get()
    } else {
      fbeValue.SocialTradingOrderMasterUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderMasterUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderMasterUpdateReset.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderMasterUpdateReset = this.SocialTradingOrderMasterUpdateReset.get()
    } else {
      fbeValue.SocialTradingOrderMasterUpdateReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderMasterUpdateReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialType.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInitialType = this.SocialTradingOrderInitialType.get()
    } else {
      fbeValue.SocialTradingOrderInitialType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialInvestorUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInitialInvestorUpdate = this.SocialTradingOrderInitialInvestorUpdate.get()
    } else {
      fbeValue.SocialTradingOrderInitialInvestorUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialInvestorUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialInvestorUpdateReset.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInitialInvestorUpdateReset = this.SocialTradingOrderInitialInvestorUpdateReset.get()
    } else {
      fbeValue.SocialTradingOrderInitialInvestorUpdateReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialInvestorUpdateReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialMasterUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInitialMasterUpdate = this.SocialTradingOrderInitialMasterUpdate.get()
    } else {
      fbeValue.SocialTradingOrderInitialMasterUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialMasterUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingOrderInitialMasterUpdateReset.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingOrderInitialMasterUpdateReset = this.SocialTradingOrderInitialMasterUpdateReset.get()
    } else {
      fbeValue.SocialTradingOrderInitialMasterUpdateReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingOrderInitialMasterUpdateReset.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderUpdate}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderUpdate}
   * @param {!OrderUpdate} fbeValue OrderUpdate value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderUpdate}
   * @param {OrderUpdate} fbeValue OrderUpdate value
   */
  setFields (fbeValue) {
    this.Key.set(fbeValue.Key)
    this.ParentOrderId.set(fbeValue.ParentOrderId)
    this.ParentOrderIdReset.set(fbeValue.ParentOrderIdReset)
    this.ActualVersion.set(fbeValue.ActualVersion)
    this.SymbolId.set(fbeValue.SymbolId)
    this.OrderSide.set(fbeValue.OrderSide)
    this.OrderType.set(fbeValue.OrderType)
    this.OrderInitialType.set(fbeValue.OrderInitialType)
    this.OrderTimeInForce.set(fbeValue.OrderTimeInForce)
    this.OrderTimeInForceReset.set(fbeValue.OrderTimeInForceReset)
    this.OrderStatus.set(fbeValue.OrderStatus)
    this.Price.set(fbeValue.Price)
    this.PriceReset.set(fbeValue.PriceReset)
    this.StopPrice.set(fbeValue.StopPrice)
    this.StopPriceReset.set(fbeValue.StopPriceReset)
    this.TakeProfit.set(fbeValue.TakeProfit)
    this.TakeProfitReset.set(fbeValue.TakeProfitReset)
    this.StopLoss.set(fbeValue.StopLoss)
    this.StopLossReset.set(fbeValue.StopLossReset)
    this.Amount.set(fbeValue.Amount)
    this.ExecutedAmount.set(fbeValue.ExecutedAmount)
    this.RemainingAmount.set(fbeValue.RemainingAmount)
    this.Expiration.set(fbeValue.Expiration)
    this.ExpirationReset.set(fbeValue.ExpirationReset)
    this.AccountComment.set(fbeValue.AccountComment)
    this.ManagerComment.set(fbeValue.ManagerComment)
    this.Magic.set(fbeValue.Magic)
    this.MagicReset.set(fbeValue.MagicReset)
    this.Created.set(fbeValue.Created)
    this.Modified.set(fbeValue.Modified)
    this.Archived.set(fbeValue.Archived)
    this.Deleted.set(fbeValue.Deleted)
    this.OpenPrice.set(fbeValue.OpenPrice)
    this.OpenPriceReset.set(fbeValue.OpenPriceReset)
    this.ClosePrice.set(fbeValue.ClosePrice)
    this.ClosePriceReset.set(fbeValue.ClosePriceReset)
    this.CloseAmount.set(fbeValue.CloseAmount)
    this.CloseAmountReset.set(fbeValue.CloseAmountReset)
    this.OpenMarginRate.set(fbeValue.OpenMarginRate)
    this.OpenMarginRateReset.set(fbeValue.OpenMarginRateReset)
    this.Commission.set(fbeValue.Commission)
    this.CommissionReset.set(fbeValue.CommissionReset)
    this.SwapChange.set(fbeValue.SwapChange)
    this.SwapChangeReset.set(fbeValue.SwapChangeReset)
    this.OpenMarkup.set(fbeValue.OpenMarkup)
    this.GatewayId.set(fbeValue.GatewayId)
    this.CloseProfit.set(fbeValue.CloseProfit)
    this.CloseProfitReset.set(fbeValue.CloseProfitReset)
    this.Opened.set(fbeValue.Opened)
    this.Closed.set(fbeValue.Closed)
    this.OpenAccountMargin.set(fbeValue.OpenAccountMargin)
    this.OpenAccountMarginReset.set(fbeValue.OpenAccountMarginReset)
    this.OpenAccountEquity.set(fbeValue.OpenAccountEquity)
    this.OpenAccountEquityReset.set(fbeValue.OpenAccountEquityReset)
    this.OpenAccountCredit.set(fbeValue.OpenAccountCredit)
    this.OpenAccountCreditReset.set(fbeValue.OpenAccountCreditReset)
    this.OpenAmount.set(fbeValue.OpenAmount)
    this.OpenAmountReset.set(fbeValue.OpenAmountReset)
    this.OrderRequestSourceType.set(fbeValue.OrderRequestSourceType)
    this.IsCreatedViaQuickTrading.set(fbeValue.IsCreatedViaQuickTrading)
    this.IsCreatedViaQuickTradingReset.set(fbeValue.IsCreatedViaQuickTradingReset)
    this.IsCreatedViaFastTrader.set(fbeValue.IsCreatedViaFastTrader)
    this.IsCreatedViaFastTraderReset.set(fbeValue.IsCreatedViaFastTraderReset)
    this.SocialTradingOrderType.set(fbeValue.SocialTradingOrderType)
    this.SocialTradingOrderInvestorUpdate.set(fbeValue.SocialTradingOrderInvestorUpdate)
    this.SocialTradingOrderInvestorUpdateReset.set(fbeValue.SocialTradingOrderInvestorUpdateReset)
    this.SocialTradingOrderMasterUpdate.set(fbeValue.SocialTradingOrderMasterUpdate)
    this.SocialTradingOrderMasterUpdateReset.set(fbeValue.SocialTradingOrderMasterUpdateReset)
    this.SocialTradingOrderInitialType.set(fbeValue.SocialTradingOrderInitialType)
    this.SocialTradingOrderInitialInvestorUpdate.set(fbeValue.SocialTradingOrderInitialInvestorUpdate)
    this.SocialTradingOrderInitialInvestorUpdateReset.set(fbeValue.SocialTradingOrderInitialInvestorUpdateReset)
    this.SocialTradingOrderInitialMasterUpdate.set(fbeValue.SocialTradingOrderInitialMasterUpdate)
    this.SocialTradingOrderInitialMasterUpdateReset.set(fbeValue.SocialTradingOrderInitialMasterUpdateReset)
  }
}

export { FieldModelOrderUpdate };

/**
 * Fast Binary Encoding OrderUpdate model
 */
class OrderUpdateModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderUpdate(this.buffer, 4)
  }

  /**
   * Get the OrderUpdate model
   * @this {!OrderUpdateModel}
   * @returns {!FieldModelOrderUpdate} model OrderUpdate model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderUpdateModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderUpdateModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderUpdateModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderUpdateModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderUpdate.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderUpdateModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderUpdateModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderUpdateModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderUpdateModel}
   * @param {!OrderUpdate} value OrderUpdate value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderUpdateModel}
   * @param {!OrderUpdate} value OrderUpdate value, defaults is new OrderUpdate()
   * @return {!object} Deserialized OrderUpdate value and its size
   */
  deserialize (value = new OrderUpdate()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderUpdate(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderUpdate(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderUpdateModel}
   * @param {!number} prev Previous OrderUpdate model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderUpdateModel };
